import React from 'react';
import { css } from 'emotion';

const titleStyle = css`
  font-weight: 500;
  letter-spacing: -0.03em;
  font-size: 1rem;
  margin: 1rem 0 1rem 0;
  line-height: 1.2em;
  color: var(--dark);
`;

export const Question = props => {
  const { title } = props;
  return <p className={titleStyle}>{title}</p>;
};
